<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Volume Label</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on, attrs }" v-if="$store.state.currentPagePriv.create">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                      New Volume Label
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span>Ukuran Botol</span>
                            <v-select filled rounded dense :items="bottles" item-text="description" item-value="code" v-model="editedItem.misc_code" :rules="reqRule"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Color</span>
                            <v-dialog v-model="colorDialog" max-width="300">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.color"
                                  label="Select color"
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <template v-slot:prepend-inner>
                                    <div
                                      :style="{
                                        backgroundColor: editedItem.color,
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: '4px'
                                      }"
                                    ></div>
                                  </template>
                                </v-text-field>
                              </template>

                              <v-card>
                                <v-color-picker
                                  v-model="editedItem.color"
                                  flat
                                  hide-mode-switch
                                ></v-color-picker>

                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn text @click="colorDialog = false">OK</v-btn>
                                </v-card-actions>
                              </v-card>
                          </v-dialog>

                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Description</span>
                            <v-text-field
                              v-model="editedItem.description"
                              filled
                              rounded
                              dense
                              counter="300"
                              maxlength="300"
                              :rules="descRules"
                            ></v-text-field>
                        </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="body-1 text-center">Anda akan menghapus Volume Label ini?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDetail" max-width="600px">
                <v-card>
                    <v-card-title class="">
                      <span class="text-h6">Voluem Label Detail</span>
                      <v-spacer></v-spacer>
                      <v-icon color="white" @click="dialogDetail = false">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text class="pt-4">
                    <v-container>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Code:</v-col>
                          <v-col cols="8">{{ detailItem.code }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Ukuran Botol:</v-col>
                          <v-col cols="8">{{ detailItem.misc_code }} ml</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Color:</v-col>
                          <v-col cols="8">
                            <div
                                :style="{
                                  backgroundColor: detailItem.color,
                                  width: '20px',
                                  height: '20px',
                                  borderRadius: '4px',
                                  border: '1px solid #ccc',
                                }"
                              ></div>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Description:</v-col>
                          <v-col cols="8">{{ detailItem.description }}</v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogDetail = false">
                        Close
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="viewDetail(item)">
                mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                mdi-delete
            </v-icon>
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
            </template>
            <template v-slot:[`item.misc_code`]="{ item }">
              {{getMiscName(item.misc_code)}}
            </template>
            <template v-slot:[`item.color`]="{ item }">
              <div
                :style="{
                  backgroundColor: item.color,
                  width: '20px',
                  height: '20px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }"
              ></div>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              {{ truncateText(item.description, 50) }}
            </template>
        </v-data-table>
    </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      dialogDetail: false,
      detailItem: {},
      colorDialog: false,
      headers: [
        { text: 'Code', value: 'code' },
        { text: 'Ukuran Botol', value: 'misc_code' },
        { text: 'Color', value: 'color'},
        { text: 'Description', value: 'description' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      editedIndex: -1,
      editedItem: {
        color: '#1976D2',
        status: true
      },
      defaultItem: {
        color: '#1976D2',
        status: true
      },
      search: '',
      reqRule: [v => !!v || 'Harus diisi!'],
      descRules: [
        v => !!v || 'Harus diisi!',
        v => (v && v.length <= 300) || 'Maksimal 300 karakter!'
      ],
      valid: true,
      bottles: [],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Volume Label' : 'Edit Volume Label'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      truncateText(text, length) {
        if (!text) return '-'
        return text.length > length
          ? text.substring(0, length) + '...'
          : text
      },
      async initialize () {
        const misccodeResponse = await this.$store.dispatch('misccode/getObjs');
        if (misccodeResponse.data.status == 'success') {
            let dataMisscode = misccodeResponse.data.data;
            this.bottles = dataMisscode.filter((i => i.type.includes('Botol')))
        }
        
        let response = await this.$store.dispatch('volumelabel/getObjs')
        if (response.data.status=='success') this.items = response.data.data

      },
      async loadDataTable() {
        let response = await this.$store.dispatch('volumelabel/getObjs')
        if (response.data.status=='success') this.items = response.data.data
      },

      getMiscName(code) {
        if (code != null) {
          const misccode = this.bottles.find(element => element.code == code);
          return misccode ? misccode.description : code;
        }
        return '-';
      },

      viewDetail(item) {
        this.detailItem = Object.assign({}, item);
        this.dialogDetail = true;
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let url = this.$store.state.config.apiHost + "volumeLabels/" + this.editedItem.code
        let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        await this.$refs.form.validate();
        if (!this.valid) return;

        if (this.editedIndex > -1) {
          let url = this.$store.state.config.apiHost + "volumeLabels/" + this.editedItem.code
          let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
          if (response.data.status == 'success') {
            Object.assign(this.items[this.editedIndex], this.editedItem)

            this.loadDataTable()
          }
          this.close()
          
        } else {
          try {
            let url = this.$store.state.config.apiHost + "volumeLabels"
            let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
            if (response.data.status=='success'){
              this.items.push(this.editedItem)
              this.loadDataTable()
            }

            this.close()
          }
          catch (err) {
            const keyword = 'duplicate key'
            if (err.response.data.message.search(keyword) > -1){
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
            }
            else {
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
            }
          }

        }
      },
    },
  }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>